import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import GrowthIndex from '@/views/growth/index.vue'

const growthRoutes: RouteRecordRaw[] = [
  {
    path: '/growth',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [{ path: '', name: 'Growth', component: GrowthIndex }],
  },
]

export default growthRoutes
